import { alpha, styled } from '@mui/material';

export const FolderAccordion = styled('div')(({ theme }) => ({
  borderRadius: '12px',
  border: `1px solid ${theme.palette.divider}`,
  backgroundColor: alpha(theme.palette.primary.main, 0.04),
  overflow: 'hidden',
}));

export const FolderAccordionHeader = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.25),
  width: '100%',
  padding: theme.spacing(1.5, 1.75),
  border: 'none',
  background: 'none',
  font: 'inherit',
  cursor: 'pointer',
  transition: theme.transitions.create('background-color'),
  '&:hover': { backgroundColor: alpha(theme.palette.primary.main, 0.08) },
  '& .folder-chevron': {
    color: theme.palette.text.secondary,
    display: 'grid',
    placeItems: 'center',
    transition: theme.transitions.create('transform'),
  },
  '& .folder-icon': { color: theme.palette.accent.main, display: 'grid', placeItems: 'center' },
  '& .folder-name': {
    flex: 1,
    minWidth: 0,
    textAlign: 'left',
    fontSize: '0.9rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export const FolderCountPill = styled('span')(({ theme }) => ({
  flex: 'none',
  padding: theme.spacing(0.5, 1.25),
  borderRadius: '999px',
  border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
  fontSize: '0.72rem',
  fontWeight: 600,
  color: theme.palette.info.main,
}));

export const FolderBody = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 1.5, 1.5),
}));
